import { render, staticRenderFns } from "./AppCourseList.vue?vue&type=template&id=4f6e41a2&scoped=true&"
import script from "./AppCourseList.vue?vue&type=script&lang=js&"
export * from "./AppCourseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6e41a2",
  null
  
)

export default component.exports